import { Elements, useElements, useStripe } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { OAuthProvider, signInWithPopup } from 'firebase/auth'
import { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import BotIntegration from '../../../Components/BotIntegration/BotIntegration'
import ImagePath from '../../../constants/ImagePath'
import checkmark from '../../../Assets/images/checkmark.svg'
import SettingSubscription from '../../SettingScreens/SettingSubscription/SettingSubscription'

import {
  auth,
  deleteFirebaseToken,
  getFirebaseToken,
  googleProvider
} from '../../../firebase'
import { API_URL, TEST_MODE_STRIPE_PUBLISHABLE_KEY } from '../../../server'
import {
  createPasswordAPI,
  forgetPasswordAPI,
  getAdminSessionPriceAPI,
  verifyOtpForPasswordResetAPI
} from '../../../services/authService'
import '../Layout/Layout.css'
import './Headings.css'
import PaymentModal from './PaymentModal'
import { MoveRight } from 'lucide-react'
const stripePromise = loadStripe(TEST_MODE_STRIPE_PUBLISHABLE_KEY)

const Headings = props => {
  const [isTokenFound, setTokenFound] = useState(null)
  const tokenInitialized = useRef(false)
  const inputRefs = useRef([])
  const [otpChecking, setOtpChecking] = useState(false)
  const [passwordValue, setPasswordValue] = useState('')
  const [nameValue, setNameValue] = useState('')
  const [snackbarVisible, setSnackbarVisible] = useState(false)
  const [accountReady, setAccountReady] = useState(false)
  const [subscriptionDetails, setSubscriptionDetails] = useState(null)

  const [subscriptionModal, setSubscriptionModal] = useState(false)

  const navigate = useNavigate()

  // strip modal
  const [stripmodal, setStripmodal] = useState(false)
  const [price, setPrice] = useState()
  const [cuurency, setCuurency] = useState('')
  const [clientSecret, setClientSecret] = useState('')
  const [striploading, setStriploading] = useState(false)
  const [IsProcessing, setIsProcessing] = useState(false)
  const [sessionCount, setSessionCount] = useState(null)
  const stripe = useStripe()
  const elements = useElements()

  //error related hooks started
  const [addressError, setAddressError] = useState('')
  const [showAddressError, setShowAddressError] = useState(false)
  const [isValidEmail, setIsValidEmail] = useState(true)
  const [otpError, setOtpError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [nameError, setNameError] = useState('')
  const [loginPasswordError, setLoginPasswordError] = useState(false)
  const [invalidPasswordError, setInvalidPasswordError] = useState('')
  //error related hooks ended

  //modal hooks started
  const [account, setAccount] = useState(false)
  const [address, setAddress] = useState(false)
  const [otp, setOtp] = useState(false)
  const [password, setPassword] = useState(false)
  const [name, setName] = useState(false)
  const [enterLoginPassword, setenterLoginPassword] = useState(false)
  const [loginPassword, setLoginPassword] = useState('')
  const [button, setButton] = useState(false)
  const [amount, setAmount] = useState(false)
  const [end, setEnd] = useState(false)
  const [isSignedIn, setIsSignedIn] = useState(false)
  const isLoggedIn = sessionStorage.getItem('islogin')
  const [signout, setSignOut] = useState(false)

  // Subject selection modal state
  const [subjectModal, setSubjectModal] = useState(false)
  const [selectedSubject, setSelectedSubject] = useState('')

  //Ai chat boat
  const [isChatOpen, setIsChatOpen] = useState(false)
  const [botId, setBotId] = useState('defaultBotId')
  const [botProfiles, setBotProfiles] = useState([]) // Store bot profiles
  // const [botLoading, setBotLoading] = useState(true);

  // const [isChatOpen, setIsChatOpen] = useState(false);
  // const [botId, setBotId] = useState("defaultBotId");

  const [emailAddress, setEmailAddress] = useState(null)
  const [passwordShown, setPasswordShown] = useState(false)

  const token = sessionStorage.getItem('token')
  const user_id = sessionStorage.getItem('user_id')
  const registerid = sessionStorage.getItem('registerid')
  const profileStatus = sessionStorage.getItem('profile')
  const username = sessionStorage.getItem('username')

  const location = useLocation()
  const loc = location?.state
  const [status, setStatus] = useState(true)
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const modalopen = true

  //forgetPassword api started
  const [forgetModuleEmail, setForgetModuleEmail] = useState(false)
  const [forgetOtpModule, setForgetOtpModule] = useState(false)
  const [forgetModuleEmailValue, setForgetModuleEmailValue] = useState('')
  const [forgetOtpValue, setForgetOtpValue] = useState('')
  const [otpErrorMessage, setotpErrorMessage] = useState('')
  const [forgetPasswordModule, setForgetPasswordModule] = useState(false)
  const [forgetPasswordValue, setForgetPasswordValue] = useState('')
  const [forgetPasswordError, setForgetPasswordError] = useState('')
  const forgetuserid = sessionStorage.getItem('user_id')
  const [isSubmitting, setIsSubmitting] = useState(false)

  //subject releted
  const [subCategories, setSubCategories] = useState([])
  const [groupedCategories, setGroupedCategories] = useState({})

  const currencySymbols = {
    GBP: '£',
    USD: '$',
    EUR: '€',
    AUD: 'A$'
  }

  const handleSubjectSelection = async () => {
    if (isSubmitting) return

    setIsSubmitting(true)

    const token = sessionStorage.getItem('token')
    const user_id = sessionStorage.getItem('user_id')

    console.log('User ID:', user_id)
    console.log('Selected Subject:', selectedSubject)

    try {
      const response = await fetch(
        'https://learnatrecess.com:7001/bookSubjectForUser',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id,
            subject: selectedSubject
          })
        }
      )

      const text = await response.text()
      const result = JSON.parse(text)

      console.log('Raw API response:', result)

      if (!response.ok) {
        // backend message like "already using this subject"
        alert(result.message)
        return
      }

      navigate('/')
      subjectClose()
      setAccountReady(true)
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  // Fetch bot profiles on component mount
  useEffect(() => {
    const fetchBotProfiles = async () => {
      try {
        // setBotLoading(true);
        const requestOptions = {
          method: 'GET',
          redirect: 'follow'
        }

        const response = await fetch(
          'https://learnatrecess.com:7001/getAllBotProfileLite',
          requestOptions
        )
        const result = await response.json()

        console.log('Bot profiles API response:', result) // Debug log

        if (result && result.Status === true && Array.isArray(result.data)) {
          setBotProfiles(result.data)

          // Use the actual bot_id from the first bot in the response
          if (result.data.length > 0 && result.data[0].bot_id) {
            setBotId(result.data[0].bot_id)
            console.log('✅ Valid bot ID set:', result.data[0].bot_id)
          } else {
            console.error('No valid bot_id found in response')
          }
        } else {
          console.error('Invalid bot profiles response:', result)
        }
      } catch (error) {
        console.error('Error fetching bot profiles:', error)
      } finally {
        // setBotLoading(false);
      }
    }

    fetchBotProfiles()
  }, [])

  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const response = await fetch(`${API_URL}getAllSubCategory`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          redirect: 'follow'
        })

        const result = await response.json()
        if (result.Status && Array.isArray(result.data)) {
          setSubCategories(result.data)

          // Group subjects by categoryText
          const grouped = result.data.reduce((acc, subCategory) => {
            const { categoryText } = subCategory
            if (!acc[categoryText]) acc[categoryText] = []
            acc[categoryText].push(subCategory)
            return acc
          }, {})
          setGroupedCategories(grouped)
        } else {
          console.error('Invalid response:', result)
        }
      } catch (error) {
        console.error('Error fetching subcategories:', error)
      }
    }

    fetchSubCategories()
  }, [])

  const [keyname, setkeyname] = useState('')

  const handleChatIconClick = event => {
    // prevent parent click handler (callFlow) from running when image is clicked
    if (event && event.stopPropagation) event.stopPropagation()

    // If user is not signed in -> show sign-in modal only
    const regId = sessionStorage.getItem('registerid')
    if (!regId) {
      // open sign-in flow that already exists in this component
      accountShow() // shows the account (email/google/apple) modal
      return
    }

    // If signed in but not subscribed -> show subscription modal
    const subscription = sessionStorage.getItem('subscription') === 'true'
    if (!subscription) {
      setSubscriptionModal(true)
      return
    }

    // signed + subscribed -> open bot (or error if bot unavailable)
    if (!botId) {
      console.error('No valid bot ID available')
      alert('Chat feature is unavailable. Try again later.')
      return
    }

    setIsChatOpen(prev => !prev)
  }

  // // Subject selection handlers
  const subjectClose = () => setSubjectModal(false)

  const subjectShow = () => {
    setName(false)
    setSubjectModal(true)
  }

  const handleSubjectSelect = subject => {
    setSelectedSubject(subject)
  }

  const handleClearSelection = () => {
    setSelectedSubject('')
  }
  //   forgot otp related functionality started

  const retriveGoogle_credationals = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider)
      const user = result.user
      console.log('User Info:', user)
      handelGoogle_login(user)
    } catch (error) {
      console.error('Error during sign in:', error)
    }
  }

  const handelGoogle_login = async items => {
    const profiledata = sessionStorage.getItem('profile')
    try {
      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')

      const raw = JSON.stringify({
        email: items?.email,
        token: isTokenFound,
        device_id: '23456'
      })

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }

      const result = await fetch(API_URL + `googleLogin`, requestOptions)
      const data = await result.json()
      console.log('result', data)
      if (!result.ok) {
        throw new Error('somenthing went wrong..')
      }
      sessionStorage.setItem('token', data?.data?.tokens?.accessToken)
      sessionStorage.setItem('registerid', data?.data?._id)
      sessionStorage.setItem('user_id', data?.data?._id)
      sessionStorage.setItem('username', data?.data?.name)
      sessionStorage.setItem('email', items?.email)
      sessionStorage.setItem('profile', data?.data?.profile)
      sessionStorage.setItem('stripId', data?.data?.accountId)
      if (!data?.data?.profile) {
        const userName = data?.data?.email.split('@')[0]
        console.log('userName', userName)
        createnewpassword(data?.data?._id, userName, userName)
      }
      accountClose()
      if (data?.data?.profile) {
        setEnd(true)
      }
      setIsSignedIn(true)
      sessionStorage.setItem('islogin', true)
    } catch (error) {
      console.log(error)
    }
  }

  const handleAppleLogin = async () => {
    const provider = new OAuthProvider('apple.com')
    try {
      // Trigger sign-in
      const result = await signInWithPopup(auth, provider)
      console.log('apple result', result)
      // Get the Apple ID token and access token from the result
      const credential = OAuthProvider.credentialFromResult(result)
      const user = result.user
      handelGoogle_login(user)
      console.log('User info:', user)
      console.log('Credential:', credential)
    } catch (error) {
      console.error('Error during sign-in:', error)
    }
  }

  useEffect(() => {
    verifyuser()
    approveornot()
    showname()
    if (!tokenInitialized.current) {
      getFirebaseToken(setTokenFound)
      tokenInitialized.current = true // Mark as initialized
    }
  }, [])

  useEffect(() => {
    getAmount()
  }, [])

  // useEffect(() => {
  //   if (status === loc) {
  //     navigate("/");
  //     accountShow();
  //   } else {
  //   }
  // }, [location]);

  useEffect(() => {
    if (status === loc) {
      navigate('/')
      accountShow()
    } else {
    }
  }, [location])

  useEffect(() => {
    const handler = e => {
      accountShow()
    }

    window.addEventListener('recess:openSignIn', handler)
    return () => {
      window.removeEventListener('recess:openSignIn', handler)
    }
  }, [])

  const handleSignIn = () => {
    //all values should be empty started
    setEmailAddress('')
    setPasswordValue('')
    setNameValue('')
    setLoginPassword('')
    setLoginPasswordError('')
    setInvalidPasswordError('')
    setForgetModuleEmail('')
    setShowAddressError('')
    setForgetPasswordValue('')
    setShowAddressError('')
    setForgetModuleEmailValue('')
    setotpErrorMessage('')
    setForgetPasswordValue('')
    setForgetPasswordError('')
    //all values should be empty ended
    navigate('/', { state: true })

    // accountShow();
  }

  const signoutClose = () => setSignOut(false)

  const handleSignOut = () => {
    setSignOut(true)
    sessionStorage.setItem('islogin', false)
    deleteFirebaseToken(setTokenFound)
  }

  const confirmSignOut = () => {
    setIsSignedIn(false)
    setSignOut(false)
    sessionStorage.clear()
    // localStorage.clear();
    navigate('/')
  }
  //modal hook is ended

  useEffect(() => {
    if (profileStatus === 'true') {
      setIsSignedIn(true)
      sessionStorage.setItem('islogin', true)
    } else {
      setIsSignedIn(false)
      sessionStorage.setItem('islogin', false)
    }
  }, [profileStatus])

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown)
  }

  const handleInputChange = event => {
    const email = event.target.value
    setEmailAddress(email)

    if (email === '') {
      setShowAddressError(false)
      setAddressError('')
    } else if (validateEmail(email)) {
      setIsValidEmail(true)
      setShowAddressError(false)
      setAddressError('')
    } else {
      setIsValidEmail(false)
      setAddressError('Please enter a valid email address.')
      setShowAddressError(true)
    }
  }

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.(com|net|org|in|co\.in|edu|gov)$/i
    return emailRegex.test(email)
  }

  //  related to otp module started
  const handleSubmit = event => {
    event.preventDefault()
    const otp = inputRefs.current.map(input => input.value).join('')
    otpVerification(otp)
  }

  const handleChange = (e, index) => {
    const value = e.target.value
    // Allow only digits and move forward only if a digit is entered
    if (/^\d$/.test(value)) {
      inputRefs.current[index].value = value // Set value explicitly to handle direct input
      if (index < 5) {
        inputRefs.current[index + 1].focus() // Move to next field
      }
    } else if (value === '') {
      // Allow empty input to clear the field without moving the cursor automatically
      inputRefs.current[index].value = '' // Clear field
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !inputRefs.current[index].value && index > 0) {
      // If backspace on empty field, move to previous field
      inputRefs.current[index - 1].focus()
    } else if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1].focus() // Move left with arrow key
    } else if (e.key === 'ArrowRight' && index < 5) {
      inputRefs.current[index + 1].focus() // Move right with arrow key
    }
  }

  const clearOtpInputs = () => {
    inputRefs.current.forEach(input => (input.value = ''))
    inputRefs.current[0].focus()
  }

  //modal related modal open and and close started
  const accountClose = () => {
    setAccount(false)
  }
  const accountShow = () => {
    setPassword(false)
    setAddress(false)
    setOtp(false)
    setAccount(true)
  }

  const addressClose = () => setAddress(false)

  const addressShow = () => {
    setPassword(false)
    accountClose(false)
    setAccount(false)
    setOtp(false)
    setAddress(true)
    enterLoginPasswordClose(false)
  }

  const otpClose = () => setOtp(false)

  const otpShow = () => {
    signIn()
    setShowAddressError(false)
    setOtp(true)
    setPassword(false)
    accountClose(false)
    setAddress(false)
    setAddressError('')
  }

  const passwordClose = () => setPassword(false)

  const passwordShow = () => {
    setName(false)
    setOtp(false)
    setPassword(true)
  }

  const nameClose = () => setName(false)

  const nameShow = () => {
    const hasUpperCase = /[A-Z]/.test(passwordValue)
    const hasLowerCase = /[a-z]/.test(passwordValue)
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(passwordValue)
    const hasNumber = /\d/.test(passwordValue) // Check for at least one digit (0-9)

    if (passwordValue === '') {
      setPasswordError('Password cannot be empty.')
    } else if (passwordValue.length < 8) {
      setPasswordError('Password must be at least 8 characters long.')
    } else if (!hasUpperCase) {
      setPasswordError('Password must contain at least one uppercase letter.')
    } else if (!hasLowerCase) {
      setPasswordError('Password must contain at least one lowercase letter.')
    } else if (!hasSpecialChar) {
      setPasswordError('Password must contain at least one special character.')
    } else if (!hasNumber) {
      setPasswordError('Password must contain at least one number.')
    } else {
      setPasswordError('')
      setenterLoginPassword(false)
      setPassword(false)
      setName(true)
    }
  }

  const enterLoginPasswordClose = () => setenterLoginPassword(false)

  const enterLoginPasswordShow = () => {
    sessionStorage.setItem('profile', true)
    if (nameValue === '') {
      setNameError('Name cannot be empty.')
    } else {
      setNameError('')
      setName(false)
      // createnewpassword()

      // setAmount(true);
      //  // Show subject modal instead of directly creating password
      subjectShow()
    }
  }

  const amountClose = () => {
    // setAmount(false);
    closestripModal()
    setIsSignedIn(true)
    sessionStorage.setItem('islogin', true)
    window.location.reload()
  }
  const amountShow = () => {
    setenterLoginPassword(false)
    setEnd(true)
  }
  const endClose = () => {
    setIsSignedIn(true)
    sessionStorage.setItem('islogin', true)
    setEnd(false)
    window.location.reload()
  }
  useEffect(() => {
    const token = sessionStorage.getItem('token')
    console.log('price token', token)
    if (!token) {
      console.log('Token not available yet')
      return
    }
    const getadminsubscriptionprice = () => {
      const myHeaders = new Headers()
      myHeaders.append('Authorization', 'Bearer ' + token)

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      }

      fetch(API_URL + 'getAdminSubscriptionPrice', requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log('FULL RESULT:', result)
          console.log('DATA:', result?.data)
          console.log('FIRST ITEM:', result?.data?.[0])
          console.log('getAdminSubscriptionPrice', result)
          setSubscriptionDetails(result.data[0])
        })
        .catch(error => console.error(error))
    }

    getadminsubscriptionprice()
  }, [token])

  const currency = currencySymbols[subscriptionDetails?.currency] || '$'

  const verifyuser = () => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + token)

    const raw = JSON.stringify({
      expert_id: registerid
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'getBexomeExpertById', requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.Status == true) {
          sessionStorage.setItem(
            'checkingverification',
            result.data[0].adminStatus
          )
        }
      })
      .catch(error => console.error(error))
  }
  //modal related open and close ended

  const pathname = location.pathname

  const getActiveTab = () => {
    if (pathname === '/') return 'Flow'
    if (pathname.includes('/CardCourses')) return 'Courses'
    if (pathname.includes('/HomeScreen')) return 'homeScreen'
    if (pathname.includes('/Industry')) return 'Industry'
    if (pathname.includes('/SettingsMainScreen')) return 'settingMainScreen'
    return ''
  }

  const activeTab = getActiveTab()

  const expertscreen = screen => {
    if (screen === 'Flow') {
      navigate('/')
    } else if (screen === 'Courses') {
      navigate('/CardCourses')
    } else if (screen === 'homeScreen') {
      navigate('/HomeScreen')
    } else if (screen === 'Industry') {
      navigate('/Industry')
    } else if (screen === 'settingMainScreen') {
      // if (registerid === null) {
      //     navigate('/', { state: true });
      // } else {

      // }
      navigate('/SettingsMainScreen/SettingNameScreen')
    }
    sessionStorage.removeItem('viapayment')
  }

  // const signIn = () => {
  //   // Perform validation checks before proceeding
  //   if (!emailAddress) {
  //     setAddressError("Email address cannot be empty.");
  //     setIsValidEmail(false);
  //     setShowAddressError(true);
  //     return;
  //   } else if (!validateEmail(emailAddress)) {
  //     setAddressError("Please enter a valid email address.");
  //     setIsValidEmail(false);
  //     setShowAddressError(true);
  //     return;
  //   }

  //   const myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");

  //   const raw = JSON.stringify({
  //     email: emailAddress,
  //     token: isTokenFound,
  //     device_id: "23456",
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };
  //   console.log("loginn raw", raw);
  //   fetch(API_URL + "userRegistration", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log("result", result);
  //       if (result.Status == true) {
  //         console.log("signIn ", result.data.emailotp);
  //         sessionStorage.setItem("token", result.data.tokens.accessToken);
  //         sessionStorage.setItem("registerid", result.data._id);
  //         sessionStorage.setItem("userEmail", result?.data);
  //         sessionStorage.setItem("email", result?.data?.email);
  //         sessionStorage.setItem("customerId", result?.data?.customerId);

  //         setAddress(false);
  //         setOtp(true);
  //         //otpShow();
  //       } else if (result.Status == false) {
  //         console.log("signIn ", result);
  //         setAddress(false);
  //         setenterLoginPassword(true);
  //         sessionStorage.setItem("token", result.data.tokens.accessToken);
  //         sessionStorage.setItem("registerid", result.data._id);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const signIn = () => {
    if (!emailAddress) {
      setAddressError('Email address cannot be empty.')
      setShowAddressError(true)
      return
    }
    if (!validateEmail(emailAddress)) {
      setAddressError('Please enter a valid email address.')
      setShowAddressError(true)
      return
    }

    const raw = JSON.stringify({
      email: emailAddress,
      token: isTokenFound,
      device_id: '23456'
    })

    fetch(API_URL + 'userRegistration', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: raw
    })
      .then(response => response.json())
      .then(result => {
        console.log('result', result)

        if (result.Status === false) {
          // EXISTING USER → LOGIN
          setAddress(false)
          setenterLoginPassword(true)

          sessionStorage.setItem('registerid', result.data._id)
          sessionStorage.setItem('user_id', result.data._id)
        }

        if (result.Status === true) {
          // NEW USER → OTP
          setAddress(false)
          setOtp(true)

          sessionStorage.setItem('token', result.data.tokens.accessToken)
          sessionStorage.setItem('registerid', result.data._id)
          sessionStorage.setItem('user_id', result.data._id)
          sessionStorage.setItem('customerId', result?.data?.customerId)
        }
      })
      .catch(error => console.error(error))
  }

  const signInAgain = () => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
      email: emailAddress,
      token: isTokenFound,
      device_id: '23456'
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'userRegistration', requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.Status == true) {
          console.log('signIn ', result.data.emailotp)

          // Show snackbar for 3 seconds
          setSnackbarVisible(true)
          setTimeout(() => setSnackbarVisible(false), 3000)
          // here snack bar model
          sessionStorage.setItem('token', result.data.tokens.accessToken)
          sessionStorage.setItem('registerid', result.data._id)
          sessionStorage.setItem('email', result?.data?.email)
          sessionStorage.setItem('customerId', result?.data?.customerId)
        } else if (result.Status == false) {
          console.log('signIn ', result)
          sessionStorage.setItem('token', result.data.tokens.accessToken)
          sessionStorage.setItem('registerid', result.data._id)
        }
      })
      .catch(error => console.error(error))
  }
  //sign api ended

  //   otp api started
  const otpVerification = funotp => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + token)

    const raw = JSON.stringify({
      email: emailAddress,
      emailotp: funotp
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'userOtpVerify', requestOptions)
      .then(response => response.json())
      .then(result => {
        // if (result.Status === true) {
        //   setOtpChecking(true);
        //   setOtpError("");
        //   sessionStorage.setItem("user_id", result.data._id);
        //   console.log("userOtpVerify", result);
        //   passwordShow();
        if (result.Status === true) {
          sessionStorage.setItem('user_id', result.data._id)

          const isNewUser =
            !result.data.password ||
            result.data.password === '' ||
            result.data.profile === false

          if (isNewUser) {
            // NEW USER → Create password
            passwordShow()
          } else {
            // EXISTING USER → Go back to login
            setOtp(false)
            setenterLoginPassword(true)
          }
        } else {
          setOtpChecking(false)
          setOtpError('Invalid OTP')
          clearOtpInputs()
        }
      })
      .catch(error => {
        console.error(error)
        setOtpChecking(false)
        setOtpError('An error occurred. Please try again.')
      })
  }

  // otp api ended

  //createNewPassword api started
  const createnewpassword = (_id, userName, Password) => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
      user_id: _id ? _id : user_id,
      password: Password ? Password : passwordValue,
      name: userName ? userName : nameValue
    })

    console.log('raw..........', raw)

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'createNewPassword', requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log('createNewPassword', result)
        sessionStorage.setItem('profile', result.data.profile)
        sessionStorage.setItem('registerid', result.data._id)
        // openstripModal();
      })
      .catch(error => console.error(error))
  }
  //createNewPassword api ended

  //login api started
  const userLogin = () => {
    if (loginPassword.trim() === '') {
      setLoginPasswordError(true)
      setInvalidPasswordError('')
      return
    } else {
      setLoginPasswordError(false)
    }
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + token)

    const raw = JSON.stringify({
      email: emailAddress,
      password: loginPassword,
      token: isTokenFound,
      device_id: 'di'
    })
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }
    console.log('raw of login', raw)
    fetch(API_URL + 'userLogin', requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log('userLogin ::', result)
        if (result.Status == true) {
          sessionStorage.setItem('userProfile', JSON.stringify(result.data))
          sessionStorage.setItem('profile', result.data.profile)
          sessionStorage.setItem('user_id', result.data._id)
          sessionStorage.setItem('registerid', result.data._id)
          sessionStorage.setItem('username', result.data.name)
          sessionStorage.setItem('token', result.data.tokens.accessToken)
          sessionStorage.setItem('userEmail', result?.data?.email)
          sessionStorage.setItem('stripId', result?.data?.accountId)
          sessionStorage.setItem('email', result?.data?.email)
          sessionStorage.setItem('customerId', result?.data?.customerId)

          setenterLoginPassword(false)
          setEnd(true)
          // openstripModal();
          setInvalidPasswordError('')
        } else {
          console.log('error :: invalid password')
          setInvalidPasswordError(
            result.message || 'Invalid password. Please try again.'
          )
          // setInvalidPasswordError('Invalid password. Please try again.')
        }
      })
      .catch(error => {
        console.error(error)
        setInvalidPasswordError('An error occurred. Please try again.')
      })
  }

  const forgetPasswordClose = () => {
    setForgetPasswordModule(false)
  }
  const forgetOtpModuleClose = () => setForgetOtpModule(false)
  const forgetOtpModuleShow = () => {
    forgetPasswordClose()
    setForgetOtpModule(true)
  }
  const handleOtpSubmit = event => {
    event.preventDefault()
    const otp = inputRefs.current.map(input => input.value).join('')
    if (otp.length === 6) {
      otpreset(otp)
    } else {
      setotpErrorMessage('Invalid Otp Please Enter Again!!')
    }
  }
  const handleOtpChange = (e, index) => {
    const value = e.target.value
    if (/^[0-9]*$/.test(value)) {
      // Allow only numeric input
      inputRefs.current[index].value = value // Set the value explicitly
      if (value.length === 1 && index < 5) {
        inputRefs.current[index + 1].focus()
      }
    }
    const otpValue = inputRefs.current.map(ref => ref.value).join('')
    if (otpValue.length === 6) {
      setotpErrorMessage('')
      otpreset(otpValue)
    }
  }

  const handleOtpKeyDown = (e, index) => {
    if (e.key == 'Backspace' && index > 0 && !inputRefs.current[index].value) {
      inputRefs.current[index - 1].focus()
    }
  }

  //   forgot otp related functionality ended

  const forgetModuleEmailClose = () => setForgetModuleEmail(false)
  const forgetModuleEmailShow = () => {
    setForgetOtpModule(false)
    enterLoginPasswordClose()
    setForgetModuleEmail(true)
  }

  const ForgetPassword = async () => {
    console.log(
      'forgetModuleEmailValue',
      forgetModuleEmailValue,
      'emailAddress',
      emailAddress
    )

    if (!forgetModuleEmailValue) {
      setAddressError('Email address cannot be empty.')
      setIsValidEmail(false)
      setShowAddressError(true)
      return
    } else if (!validateEmail(forgetModuleEmailValue)) {
      setAddressError('Please enter a valid email address.')
      setIsValidEmail(false)
      setShowAddressError(true)
      return
    } else if (
      forgetModuleEmailValue.toLowerCase() !== emailAddress.toLowerCase()
    ) {
      setAddressError('Please enter the current email address.')
      setIsValidEmail(false)
      setShowAddressError(true)
      return
    }

    try {
      const result = await forgetPasswordAPI(forgetModuleEmailValue, token)
      console.log('forgetPassword', result)

      if (result.Status === true) {
        // Show snackbar for 3 seconds
        setSnackbarVisible(true)
        setTimeout(() => setSnackbarVisible(false), 3000)
        sessionStorage.setItem('user_id', result.data._id)
        sessionStorage.setItem('registerid', result.data._id)
        setAddressError('')
        setForgetOtpValue(result.data.emailotp)
        setForgetModuleEmail(false)
        setForgetOtpModule(true)
      }
    } catch (error) {
      console.error('ForgetPassword error:', error)
    }
  }

  //ForgetPasswordAgain
  const ForgetPasswordAgain = async () => {
    try {
      const result = await forgetPasswordAPI(forgetModuleEmailValue, token)
      console.log('forgetPassword', result)

      if (result.Status === true) {
        sessionStorage.setItem('user_id', result.data._id)
        sessionStorage.setItem('registerid', result.data._id)
      }
    } catch (error) {
      console.error('ForgetPassword error:', error)
    }
  }

  //otpreset
  const otpreset = async otpresetvalue => {
    try {
      const result = await verifyOtpForPasswordResetAPI(
        forgetModuleEmailValue,
        otpresetvalue,
        token
      )
      if (result.Status === true) {
        console.log('verifyOtpForPasswordReset', result)
        setForgetOtpModule(false)
        setForgetPasswordModule(true)
      } else {
        setotpErrorMessage('Invalid Otp Please Enter Again!!')
      }
    } catch (error) {
      console.error('OTP Reset Error:', error)
    }
  }

  const forgetenternewpassword = async () => {
    if (forgetPasswordValue.length >= 8) {
      setForgetPasswordError('')

      try {
        const result = await createPasswordAPI(user_id, '', forgetPasswordValue)
        console.log('createNewPassword', result)

        if (result.Status === true) {
          setForgetPasswordModule(false)
          setAccount(true)
        }
      } catch (error) {
        console.error('Forget New Password Error:', error)
      }
    } else {
      setForgetPasswordError('Password must be at least 8 characters long.')
    }
  }

  //approveornot
  const approveornot = () => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + token)

    const raw = JSON.stringify({
      expert_id: registerid
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'getBexomeExpertById', requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.Status == true) {
          console.log('getBexomeExpertById', result.data)
          sessionStorage.setItem('approvedornot', result.data[0].adminStatus)
        }
      })
      .catch(error => console.error(error))
  }

  const showname = () => {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + token)

    const raw = JSON.stringify({
      _id: registerid
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'getUsers', requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.Status == true) {
          console.log('getUsers', result)
          sessionStorage.setItem('addname', result.data.profile.name)
          sessionStorage.setItem(
            'subscription',
            result.data.profile.subscription
          )
        }
      })
      .catch(error => console.error(error))
  }

  // strip modal
  const openstripModal = () => {
    setStripmodal(true)
  }
  const closestripModal = () => {
    setStripmodal(false)
    const subjectName = sessionStorage.getItem('subjectName')
    navigate('/', { state: { subjectName } })
  }

  const getAmount = async () => {
    try {
      const result = await getAdminSessionPriceAPI()
      console.log('getAdminSessionPrice', result)

      if (!result?.data?.length) {
        throw new Error('Data not found')
      }
      setCuurency(result.data[0].currency)
      setPrice(Number(result.data[0].sessionPrice))
    } catch (error) {
      console.log('error', error)
    }
  }

  const hanglechnagePassword = async e => {
    setPasswordError('')
    setPasswordValue(e.target.value)
  }

  const callFlow = () => {
    if (registerid === null) {
      navigate('/', {
        state: true
      })
    }
  }

  return (
    <div className='flex-1 mx-auto px-4 min-[600px]:px-2 '>
      {snackbarVisible && (
        <div
          className='addresspara'
          style={{
            position: 'fixed',
            top: '10%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#F5F3EE',
            color: 'black',
            padding: '16px 24px',
            borderRadius: '8px',
            zIndex: 9999,
            boxShadow: '0px 4px 12px rgba(0,0,0,0.2)'
          }}
        >
          Resend OTP successfully to your email.
        </div>
      )}

      <ToastContainer />
      <header className='bg-[#F5F3EE] py-3  w-full '>
        <div className='flex justify-between'>
          {/* Title */}
          <div
            onClick={() => {
              callFlow()
            }}
            className='w-full cursor-pointer md:w-auto text-3xl sm:text-4xl md:text-5xl font-normal font-recoleta text-start items-start md:text-left'
          >
            {/* <img
              className="size-8 inline"
              src={ImagePath.AppIcons}
              alt="AppIcon"
              onClick={handleChatIconClick}
            />{" "} */}
            <img
              className='size-8 inline'
              src={ImagePath.AppIcons}
              alt='AppIcon'
              onClick={e => {
                e.stopPropagation() // ensure parent click won't run
                handleChatIconClick(e)
              }}
            />{' '}
            {props.screenHeadingName || 'App Name'}
            {/* Chatbot modal rendering */}
            {/* {isChatOpen && (
        <BotIntegration
          botId={botId}
          userId="currentUser@example.com"
          onClose={() => setIsChatOpen(false)} // optional close handler
        />
      )} */}
            {/* Show loading indicator */}
            {/* {botLoading && (
              <span className="text-xs text-gray-500 ml-2">
                (Loading chat...)
              </span>
            )} */}
          </div>

          {/* Right Section */}
          <div className='flex flex-wrap justify-end md:justify-end items-end gap-4 w-full md:w-auto'>
            {/* Nav */}

            <nav className='hidden md:flex items-center space-x-6 w-[max-content]'>
              <span
                onClick={() => expertscreen('Flow')}
                className={`flex items-center gap-1.5 text-sm font-medium border-b-2 pb-1 transition-all duration-300 cursor-pointer ${
                  activeTab === 'Flow'
                    ? 'border-black'
                    : 'border-transparent hover:border-black'
                }`}
              >
                <img className='size-4' src={ImagePath.HomeImg} alt='Flow' />
                <span>Home</span>
              </span>

              <span
                onClick={() => expertscreen('Courses')}
                className={`flex items-center gap-1.5 text-sm font-medium border-b-2 pb-1 transition-all duration-300 cursor-pointer ${
                  activeTab === 'Courses'
                    ? 'border-black'
                    : 'border-transparent hover:border-black'
                }`}
              >
                <img
                  className='size-4'
                  src={ImagePath.courseimg}
                  alt='Course'
                />
                <span>Courses</span>
              </span>

              <span
                onClick={() => expertscreen('homeScreen')}
                className={`flex items-center gap-1.5 text-sm font-medium border-b-2 pb-1 transition-all duration-300 cursor-pointer ${
                  activeTab === 'homeScreen'
                    ? 'border-black'
                    : 'border-transparent hover:border-black'
                }`}
              >
                <img className='size-5' src={ImagePath.tutors} alt='Home' />
                <span>Tutors</span>
              </span>

              <span
                onClick={() => expertscreen('Industry')}
                className={`flex items-center gap-1.5 text-sm font-medium border-b-2 pb-1 transition-all duration-300 cursor-pointer ${
                  activeTab === 'Industry'
                    ? 'border-black'
                    : 'border-transparent hover:border-black'
                }`}
              >
                <img
                  className='size-4'
                  src={ImagePath.industryImg}
                  alt='Industry'
                />
                {/* <span>Industry</span> */}
                <span>Projects</span>
              </span>

              <span
                onClick={() => expertscreen('settingMainScreen')}
                className={`flex items-center gap-1.5 text-sm font-medium border-b-2 pb-1 transition-all duration-300 cursor-pointer ${
                  activeTab === 'settingMainScreen'
                    ? 'border-black'
                    : 'border-transparent hover:border-black'
                }`}
              >
                <img src={ImagePath.person} alt='account' className='size-4' />
                <span>Account</span>
              </span>
            </nav>

            {/* Auth Button */}
            <button
              className='bg-black text-white px-4 py-1.5 rounded-md flex items-center  gap-2 whitespace-nowrap'
              onClick={profileStatus ? handleSignOut : handleSignIn}
            >
              <img
                className='size-4'
                src={require(`../../../Assets/images/${
                  profileStatus ? 'sign-out' : 'sign-in'
                }.png`)}
                alt={profileStatus ? 'Sign out' : 'Sign in'}
              />
              <span>{profileStatus ? 'Sign out' : 'Sign in'}</span>
            </button>
          </div>
        </div>
      </header>
      {/* Chatbot modal rendering */}
      {isChatOpen && botId && (
        <BotIntegration
          botId={botId}
          userId={user_id || registerid || `user-${Date.now()}`}
          onClose={() => setIsChatOpen(false)}
        />
      )}
      {/* account started popup started */}
      <div>
        <Modal centered show={account} className='flex items-center m-0 rad'>
          <Modal.Body className='modalbackgroundcolor  p-4 items-center rounded-lg'>
            <div className='flex justify-end w-full mb-2'>
              <button
                type='button'
                className='btn btn-close ms-ms-auto items-end'
                onClick={() => setAccount(false)}
              ></button>
            </div>

            <p className='poptitle py-2'>Use an account to continue</p>
            <span className='wave_img'>
              <p className='popparagraph'>
                Get{' '}
                <strong className='popparagrap3 '>
                  1 month of unlimited access{' '}
                </strong>{' '}
                to every feature, lesson, and tool when you create a new
                account.
              </p>
            </span>
            <div className='d-flex justify-content-center mt-2 mb-2'>
              <img
                className='popimage'
                src={require('../../../Assets/images/waves.png')}
              />
            </div>

            <div className='flex flex-col items-center gap-4 w-full'>
              {' '}
              {/* Main container */}
              {/* Buttons */}
              <div className='w-full flex flex-col items-center gap-4'>
                {' '}
                {/* Buttons container */}
                <div className='w-full max-w-[280px]'>
                  {' '}
                  {/* Button wrapper */}
                  <button
                    onClick={handleAppleLogin}
                    className='w-full popupbuttons1  text-white flex justify-center items-center px-6 py-3 rounded text-base font-medium transitio'
                  >
                    <i className='bi bi-apple mr-2'></i>
                    Continue with Apple
                  </button>
                </div>
                <div className='w-full max-w-[280px]'>
                  <button
                    onClick={() => retriveGoogle_credationals()}
                    className='w-full popupbuttons2   flex justify-center items-center px-6 py-3 rounded text-base font-bold transition'
                  >
                    <img
                      className='w-5 h-5 mr-2'
                      src={require('../../../Assets/images/google.png')}
                      alt='Google'
                    />
                    Continue with Google
                  </button>
                </div>
                <div className='w-full max-w-[280px]'>
                  <button
                    onClick={addressShow}
                    className='w-full popupbuttons3 flex justify-center items-center px-6 py-3 rounded text-base font-bold transition'
                  >
                    <i className='bi bi-envelope-fill mr-2'></i>
                    Use email address
                  </button>
                </div>
              </div>
              {/* Policy Text */}
              <div className='text-center pt-4 max-w-[280px]'>
                <p className='text-sm text-gray-600'>
                  By signing up, you agree to our{' '}
                  <a
                    href='https://www.hub.recess.education/terms-and-conditions'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-black font-semibold hover:underline'
                  >
                    Terms
                  </a>
                  . See how we use your data in our{' '}
                  <a
                    href='https://www.hub.recess.education/privacy-policy'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-black font-semibold hover:underline'
                  >
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      {/* account started popup ended */}

      {/* address popup started */}
      <Modal centered show={address} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor  p-8 items-center rounded-lg'>
          <div className='d-flex justify-content-between align-items-center mb-4'>
            <div>
              <button
                onClick={() => accountShow()}
                className='addressback d-flex align-items-center'
              >
                <img
                  src={ImagePath.leftarrow}
                  style={{ height: '15px', width: '15px' }}
                />
                &nbsp;&nbsp;Back
              </button>
            </div>
            <div>
              <button
                type='button'
                className='btn btn-close ms-auto mb-2'
                onClick={addressClose}
              ></button>
            </div>
          </div>
          <div className='mt-4 mb-6 space-y-3 ml-3 mr-3'>
            <p className='addressheader'>What’s your email?</p>
            <p className='addresspara'>
              We verify all accounts to create a genuine learning community with
              real Learners and tutors.
            </p>
            <div className='mt-4 mb-4 space-y-3'>
              <p className='address'>Email address</p>
              <p>
                <input
                  type='email'
                  value={emailAddress}
                  onChange={handleInputChange}
                  placeholder='Enter here'
                  className='addressinput'
                />
                {showAddressError && (
                  <p style={{ color: '#7A0000' }}>{addressError}</p>
                )}
              </p>
              <p>
                <button onClick={signIn} className='addressbutton mb-5'>
                  Continue
                </button>
              </p>
            </div>
          </div>
          <div className='mt-10 mb-32'></div>
          <p className='addresspara2 flex items-center '>
            <img
              style={{
                width: '17.6px',
                height: '18px',
                marginBottom: '5px',
                marginRight: '10px'
              }}
              src={require('../../../Assets/images/lock.png')}
            />
            This information will remain confidential.
          </p>
        </Modal.Body>
      </Modal>
      {/* address popup ended */}

      {/* otp screen started  */}
      <Modal centered show={otp} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg'>
          <div className='d-flex mt-2'>
            <button
              onClick={() => addressShow()}
              className='addressback d-flex align-items-center'
            >
              <img
                src={ImagePath.leftarrow}
                style={{ height: '15px', width: '15px' }}
              />
              &nbsp;Back
            </button>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={otpClose}
            ></button>
          </div>

          <div className='ml-3 mr-3'>
            <p className='otpheader'>Verify your email</p>
            <p className='otpenteremail'>
              Enter the code we’ve sent to {emailAddress}
            </p>
            <button onClick={() => accountShow()} className='otpchangemail'>
              <u className='change_email font-bold'>Change email</u>
            </button>
            <p className='otpentercode'>Enter code</p>

            <form onSubmit={handleSubmit}>
              <div>
                {Array(6)
                  .fill(null)
                  .map((_, index) => (
                    <input
                      key={index}
                      className='otpinput'
                      type='text'
                      maxLength='1'
                      onChange={e => handleChange(e, index)}
                      onKeyDown={e => handleKeyDown(e, index)}
                      ref={el => (inputRefs.current[index] = el)}
                    />
                  ))}
                <p style={{ color: '#7A0000' }}>{otpError}</p>
              </div>

              <div>
                <button type='submit' className='otpbutton'>
                  Continue
                </button>
              </div>
            </form>
          </div>

          <div className='mt-10 mb-36'></div>
          <div className='d-flex justify-content-between mt-20'>
            <span>
              <u className='otpfooter' onClick={() => signInAgain()}>
                Didn’t get a code?
              </u>
            </span>
            <span className='otpfooter'>Step 2/4</span>
          </div>
        </Modal.Body>
      </Modal>
      {/* opt screen ended */}

      {/* password screen started */}
      <Modal centered show={password} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg'>
          <div className='d-flex mt-2'>
            <button
              onClick={otpShow}
              className='addressback d-flex align-items-center'
            >
              <img
                src={ImagePath.leftarrow}
                style={{ height: '15px', width: '15px' }}
              />
              &nbsp;&nbsp;Back
            </button>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={passwordClose}
            ></button>
          </div>
          <div className='ml-3 mr-3'>
            <p className='passheader1'>Create a password</p>
            <p className='pass'>Password</p>
            <p className='passpara'>
              {/* You need to use a minimum of eight characters at least one uppercase 
              letter one number and one special character for your password.. */}
              Use at least 8 characters, including one uppercase letter, one
              number, and one special character.
            </p>

            <div className='password-container'>
              <input
                className='passinput'
                type={passwordShown ? 'text' : 'password'}
                style={{ paddingRight: '2.5rem' }}
                placeholder='Enter here'
                value={passwordValue}
                onChange={e => hanglechnagePassword(e)}
              />
              <img
                src={
                  passwordShown == false
                    ? require('../../../Assets/images/eye_icon.png')
                    : ImagePath.eyeopen
                }
                className='eyeIcon'
                onClick={togglePasswordVisibility}
                alt='Toggle visibility'
              />
            </div>

            <p style={{ color: '#7A0000' }}>{passwordError}</p>
            <button onClick={nameShow} className='passbutton mb-5'>
              Continue
            </button>
            <div className='mt-10 mb-28'></div>
            <p className='passpageno'>Step 3/4</p>
          </div>
        </Modal.Body>
      </Modal>
      {/* password screen ended */}

      {/* name screen started */}
      <Modal centered show={name} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg'>
          <div className='d-flex mt-2'>
            <button
              onClick={passwordShow}
              className='addressback d-flex align-items-center'
            >
              <img
                src={ImagePath.leftarrow}
                style={{ height: '15px', width: '15px' }}
              />
              &nbsp;&nbsp;Back
            </button>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={nameClose}
            ></button>
          </div>
          <div className='ml-3 mr-3'>
            <p className='passheader1'>What’s your name?</p>
            <p className='pass'>Full Name</p>
            <p className='passpara'>
              You can always edit your name later in Settings.
            </p>
            <p>
              <input
                className='passinput'
                type='text'
                placeholder='Enter here'
                value={nameValue}
                onChange={e => {
                  setNameValue(e.target.value)
                }}
              />
            </p>

            <p style={{ color: '#7A0000' }}>{nameError}</p>
            <p>
              {/* <button
                onClick={enterLoginPasswordShow}
                className='passbutton mb-5'
              >
                Continue
              </button> */}
              {/* <button
                onClick={() => {
                  setName(false);
                  setAccountReady(true);

                  // NEW FIX:
                  sessionStorage.setItem("profile", "true");
                  sessionStorage.setItem("islogin", "true");
                  sessionStorage.setItem("username", nameValue);
                  sessionStorage.setItem("email", emailAddress);

                  setIsSignedIn(true);
                }}
                className="passbutton mb-5"
              >
                Continue
              </button> */}

              <button
                onClick={() => {
                  if (!nameValue.trim()) {
                    setNameError('Name cannot be empty.')
                    return
                  }
                  createnewpassword() // <-- REAL REGISTRATION
                  setName(false)
                  // setAccountReady(true)
                  setSubjectModal(true)
                }}
                className='passbutton mb-5'
              >
                Continue
              </button>
            </p>
          </div>
          <div className='mt-16 mb-36'></div>
          <p className='passpageno ml-3 mr-3'>Step 4/4</p>
        </Modal.Body>
      </Modal>
      {/* name screen ended */}

      {/* Subject Selection Modal */}
      <Modal centered show={subjectModal} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor p-4 rounded-3'>
          {/* Header */}
          <div className='flex justify-between items-center mb-4'>
            <button
              type='button'
              className='btn ms-auto p-0 border-0 bg-transparent'
              onClick={() => {
                navigate('/')
                subjectClose()
                // setStripmodal(true);
              }}
            >
              <MoveRight class='text-black mt-1' />
            </button>
          </div>

          {/* Title */}
          <div className='text-left mb-4'>
            <p className="text-[24px] fontFamily: 'Recoleta' fontWeight: 700 font-bold text-black leading-[100%]">
              Which subject do you want to <br />
              learn?
            </p>

            <p className='text-sm text-black font-[500] font-avenir mt-3'>
              We’ll personalise your learning journey based on what you choose.
              You can always change this later.
            </p>
          </div>

          {/* <hr className="border-gray-200" /> */}
          <hr className='border-t border-gray-500 my-3' />

          {/* Clear Selection */}
          {selectedSubject && (
            <>
              <button
                onClick={handleClearSelection}
                className='flex items-center text-sm text-gray-700 hover:text-black mb-3'
              >
                <img
                  src={require('../../../Assets/images/refresh.png')}
                  alt='Reset'
                  style={{ width: '15px', height: '15px', marginRight: '8px' }}
                />
                Clear Selection
              </button>
              {/* <hr className="border-gray-200 mb-3" /> */}
              <hr className='border-t border-gray-500 my-3' />
            </>
          )}

          {/* Dynamic Sections from API */}
          <div className='space-y-4'>
            {Object.keys(groupedCategories).length > 0 ? (
              Object.keys(groupedCategories).map(category => (
                <div key={category}>
                  <h3 className='text-sm font-semibold text-black mb-2'>
                    {category}
                  </h3>
                  {groupedCategories[category].map(sub => (
                    <div
                      key={sub._id}
                      onClick={() => handleSubjectSelect(sub.subject)}
                      className='flex items-center py-2 border-b border-gray-200 cursor-pointer transition-all'
                    >
                      <span
                        className={`h-4 w-4 rounded-full border-2 mr-3 flex items-center justify-center ${
                          selectedSubject === sub.subject
                            ? 'border-black'
                            : 'border-gray-400'
                        }`}
                      >
                        {selectedSubject === sub.subject && (
                          <span className='h-2 w-2 bg-black rounded-full'></span>
                        )}
                      </span>
                      <span className='text-sm text-gray-800'>
                        {sub.subject}
                      </span>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <p className='text-gray-500 text-sm text-center py-4'>
                Loading subjects...
              </p>
            )}
          </div>

          {/* Bottom Button */}
          <div className='mt-6'>
            <button
              onClick={() => {
                if (selectedSubject) {
                  handleSubjectSelection()
                } else {
                  navigate('/') // Skip flow
                  subjectClose()
                  setAccountReady(true)
                }
              }}
              className='w-full py-2 rounded-md bg-black text-white font-medium transition'
            >
              {selectedSubject ? 'Next' : 'Skip for now'}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* balance screen started */}
      <Modal centered show={amount} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg'>
          <div className='d-flex justify-content-end'>
            <button
              className='btn btn-close'
              onClick={() => setAmount(false)}
            ></button>
          </div>

          <div>
            <p className='amounthead'>Welcome,{nameValue}.</p>
            <p className='amountpara'>
              Your account is ready, which you can also use to share your own
              knowledge as an tutor. Here’s{' '}
              <span style={{ fontFamily: 'AvenirNextLTPro-Bold' }}>$10</span> in
              your wallet as a gift from us to kickstart your learning.
            </p>
            <div className='amountdisplayflex'>
              <div>
                <img
                  className='amountimage'
                  src={require('../../../Assets/images/wallet.png')}
                />
              </div>
              <div style={{ marginTop: '14px' }}>
                <p className='amountpara al mt-2'>Available balance</p>
                <p className='amount ms-5'>$10.00</p>
              </div>
            </div>
            <hr className='amountline'></hr>
            <p className='amounthead'>Earn an additional $10</p>
            <p className='amountpara'>
              If you received an Invite Code from a friend, please enter it
              below to receive an additional{' '}
              <span style={{ fontFamily: 'AvenirNextLTPro-Bold' }}>$10 </span>.
            </p>
            <p className='amount_input'>
              <input
                className='amountinput'
                type='text'
                placeholder='Enter Invite Code (optional)'
              />
            </p>
            <p className='amountbtn'>
              <button
                onClick={() => amountClose()}
                className='amountbutton passbutton'
              >
                Continue
              </button>
            </p>
          </div>
        </Modal.Body>
      </Modal>
      {/* balance screen ended */}

      {/* 2 login password screen started */}
      <Modal
        centered
        show={enterLoginPassword}
        className='flex items-center m-0 rad'
      >
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg'>
          <div className='d-flex'>
            <button
              onClick={() => addressShow()}
              className='addressback d-flex align-items-center'
            >
              <img
                src={ImagePath.leftarrow}
                style={{ height: '15px', width: '15px' }}
              />
              &nbsp;&nbsp;Back
            </button>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={enterLoginPasswordClose}
            ></button>
          </div>
          <div className='ml-3 mr-3'>
            <p className='passheader1'>Enter your password</p>
            <p className='pass'>Password</p>
            <p className='flex mt-1'>
              <input
                type={passwordShown ? 'text' : 'password'} // Change here
                placeholder='Enter here'
                className='passinput'
                value={loginPassword}
                onChange={e => setLoginPassword(e.target.value)}
              />
              <img
                src={
                  passwordShown == false
                    ? require('../../../Assets/images/eye_icon.png')
                    : ImagePath.eyeopen
                }
                className='eyeIcon'
                onClick={togglePasswordVisibility}
                alt='Toggle visibility'
              />
            </p>

            <p>
              {loginPasswordError && (
                <p style={{ color: '#7A0000' }}>Password should not be empty</p>
              )}
              {invalidPasswordError && (
                <p style={{ color: '#7A0000' }}>{invalidPasswordError}</p>
              )}
              <button onClick={userLogin} className='passbutton'>
                Continue
              </button>
            </p>

            <div className='mt-10 mb-32'></div>
            <u
              onClick={() => forgetModuleEmailShow()}
              className='passpageno float-start'
            >
              Forgot Password?
            </u>
            <span className='passpageno float-end'>Step 2/2</span>
          </div>
        </Modal.Body>
      </Modal>
      {/* enterLoginPassword screen ended */}

      {/* end module started */}
      <Modal centered show={end} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg'>
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={() => setEnd(false)}
            ></button>
          </div>
          <div>
            <p className='passheader2 endhead' style={{}}>
              Welcome back, {username}.
            </p>
            <span className='wave_img'>
              {' '}
              <img
                className='endimage'
                src={require('../../../Assets/images/strightwaves.png')}
              />
            </span>
            <p onClick={() => endClose()} className='endbutton'>
              <button
                className='passbutton'
                style={{ width: '142px', height: '32px' }}
              >
                Continue
              </button>
            </p>
          </div>
        </Modal.Body>
      </Modal>
      {/* end moudle ended */}

      {/* signout module started */}
      <Modal centered show={signout} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor  p-4 items-center rounded-lg '>
          <Modal.Header
            className='btn btn-close ms-auto'
            onClick={() => signoutClose(false)}
          ></Modal.Header>
          <h6 className='signoutheadingtext'>
            Are you sure you
            <br /> want to sign out?
          </h6>

          <img
            src={ImagePath.wavesimage}
            alt='wallet icon'
            className='wavasimge'
          />

          <div className='d-flex justify-content-center mb-5' style={{}}>
            <Button
              variant='dark'
              onClick={confirmSignOut}
              className='signoutbutton yesbtn'
            >
              Yes
            </Button>
            <Button
              variant='dark'
              className='ms-3 signoutbutton cancelbtn'
              onClick={signoutClose}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* signout module ended */}

      {/* forgatpassword modules started */}
      <Modal
        centered
        show={forgetModuleEmail}
        className='flex items-center m-0 rad'
      >
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg pb-14'>
          <div className='d-flex'>
            <button
              onClick={() => {
                setenterLoginPassword(true)
                setForgetModuleEmail(false)
              }}
              className='addressback d-flex align-items-center'
            >
              <img
                src={ImagePath.leftarrow}
                style={{ height: '15px', width: '15px' }}
              />
              &nbsp;&nbsp;Back
            </button>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={forgetModuleEmailClose}
            ></button>
          </div>

          <div className='mt-4 mb-6 space-y-3 ml-3 mr-3'>
            <div>
              <p className='addressheader'>Enter your email</p>
              <p className='addresspara1 mt-1 '>
                Enter your email and we`ll send you a code to reset your
                password.
              </p>

              <p
                className='address'
                style={{ marginTop: '30px', marginBottom: '10px' }}
              >
                Email address
              </p>
              <p>
                <input
                  type='email'
                  value={forgetModuleEmailValue}
                  onChange={e => {
                    setForgetModuleEmailValue(e.target.value)
                  }}
                  placeholder='Enter your email'
                  className='addressinput'
                />
                {showAddressError && (
                  <p style={{ color: '#7A0000' }}>{addressError}</p>
                )}
              </p>
              <p>
                <button
                  onClick={() => ForgetPassword()}
                  className='addressbutton'
                >
                  Continue
                </button>
              </p>
            </div>
          </div>
          <div className='mt-16 mb-36'></div>
          <div className='pb-5'></div>
        </Modal.Body>
      </Modal>

      {/* forget otp screen started  */}
      <Modal
        centered
        show={forgetOtpModule}
        className='flex items-center m-0 rad'
      >
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg '>
          <div className='d-flex mt-2'>
            <button
              onClick={() => forgetModuleEmailShow()}
              className='addressback d-flex align-items-center'
            >
              <img
                src={ImagePath.leftarrow}
                style={{ height: '15px', width: '15px' }}
              />
              &nbsp;Back
            </button>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={forgetOtpModuleClose}
            ></button>
          </div>

          <div className='ml-3 mr-3'>
            <p className='otpheader'>Verify your email</p>
            <p className='otpenteremail'>
              Enter the code we’ve sent to {forgetModuleEmailValue}
            </p>
            <p className='otpentercode'>Enter code</p>

            <form onSubmit={handleOtpSubmit}>
              <div>
                {Array(6)
                  .fill(null)
                  .map((_, index) => (
                    <input
                      key={index}
                      className='otpinput'
                      type='text'
                      maxLength='1'
                      onChange={e => handleOtpChange(e, index)}
                      onKeyDown={e => handleOtpKeyDown(e, index)}
                      ref={el => (inputRefs.current[index] = el)}
                    />
                  ))}
                <p style={{ color: '#7A0000', marginTop: '20px' }}>
                  {otpErrorMessage}
                </p>
              </div>

              <div>
                <button type='submit' className='otpbutton'>
                  Continue
                </button>
              </div>
            </form>
          </div>

          <div className='mt-10 mb-36'></div>
          <div className='d-flex justify-content-between mt-25 items-end'>
            <span>
              <u className='otpfooter' onClick={() => ForgetPassword()}>
                Didn’t get a code?
              </u>
            </span>
            <span className='otpfooter'></span>
            {/* Step 2/4 */}
          </div>
        </Modal.Body>
      </Modal>
      {/* forget opt screen ended */}

      {/* forgetPassword modules */}
      <Modal
        centered
        show={forgetPasswordModule}
        className='flex items-center m-0 rad'
      >
        <Modal.Body className='modalbackgroundcolor  p-7 items-center rounded-lg'>
          <div className='d-flex'>
            <button
              onClick={forgetOtpModuleShow}
              className='addressback d-flex align-items-center'
            >
              <img
                src={ImagePath.leftarrow}
                style={{ height: '15px', width: '15px' }}
              />
              &nbsp;&nbsp;Back
            </button>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={forgetPasswordClose}
            ></button>
          </div>
          <div className='ml-3 mr-3'>
            <p className='passheader1'>Create a password</p>
            <p className='pass'>Password</p>
            <p className='passpara'>
              You need to use a minimum of eight characters and at least one
              uppercase letter for your password.
            </p>

            <div className='password-container'>
              <input
                className='passinput'
                type={passwordShown ? 'text' : 'password'}
                style={{ paddingRight: '2.5rem' }}
                placeholder='Enter here'
                value={forgetPasswordValue}
                onChange={e => {
                  setForgetPasswordValue(e.target.value)
                }}
              />
              <img
                src={
                  passwordShown == false
                    ? require('../../../Assets/images/eye_icon.png')
                    : ImagePath.eyeopen
                }
                className='eyeIcon'
                onClick={togglePasswordVisibility}
                alt='Toggle visibility'
              />
            </div>
            <p style={{ color: '#7A0000' }}>{forgetPasswordError}</p>
            <button onClick={forgetenternewpassword} className='passbutton'>
              Continue
            </button>
            <p className='passpageno'>Step 3/4</p>
          </div>
        </Modal.Body>
      </Modal>
      {/* forgetPassword modules ended */}

      <SettingSubscription
        subscriptionModal={subscriptionModal}
        setSubscriptionModal={setSubscriptionModal}
      />
      <Modal centered show={accountReady} className='flex items-center m-0 rad'>
        <Modal.Body className='modalbackgroundcolor p-7 items-center rounded-lg'>
          {/* Top Row: Back + Close button (same as Name screen) */}
          <div className='d-flex mt-2'>
            <button
              onClick={() => setAccountReady(false)}
              className='addressback d-flex align-items-center'
            >
              {/* <img
                src={ImagePath.leftarrow}
                style={{ height: "15px", width: "15px" }}
              /> */}
              {/* &nbsp;&nbsp;Back */}
            </button>

            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={() => setAccountReady(false)}
            ></button>
          </div>

          {/* Inside spacing same as name modal */}
          <div className='ml-3 mr-3'>
            <p className='passheader1 mb-3'>Your account is ready.</p>

            <p className='passpara mb-4'>
              Your one-month free trial has started, giving you full access to
              all learning features.
            </p>

            {/* Benefits */}
            <div className='d-flex align-items-center gap-3 mt-4'>
              <img src={checkmark} />
              <span className='para'>
                Learn through structured courses with interactive Loops
              </span>
            </div>
            <div className='d-flex align-items-center gap-3 mt-2'>
              <img src={checkmark} />
              <span className='para'>
                Chat with expertly trained subject-specific AI tutors anytime
              </span>
            </div>
            <div className='d-flex align-items-center gap-3 mt-2'>
              <img src={checkmark} />
              {/* <span className='para'>
                Work on employer challenges through the industry portal
              </span> */}
               <span className='para'>
                Apply your skills through practical projects and challenges
              </span>
            </div>
            <div className='d-flex align-items-center gap-3 mt-2'>
              <img src={checkmark} />
              <span className='para'>
                Access curated resources, tools, and templates for each subject
              </span>
            </div>

            <p className='text-xs text-black mb-2 mt-4 font-bold'>
              {/* After your trial, it’s ${subscriptionDetails?.subscriptionPrice}/month. Cancel anytime. */}
              After your trial, it’s {currency}
              {subscriptionDetails?.subscriptionPrice}/month. Cancel anytime.
              {/* After your trial, it’s $11.99/month. Cancel anytime. */}
            </p>

            <button
              // onClick={() => {
              //   setAccountReady(false)
              //   // setSubjectModal(true)
              // }}
              onClick={() => {
                const subjectName = sessionStorage.getItem('subjectName')

                navigate('/', {
                  state: { selectedSubject: subjectName }
                })

                setAccountReady(false) // close account modal
              }}
              className='passbutton w-full mb-3'
            >
              Start learning
            </button>

            <p className='text-xs text-center text-black-600 mt-3 font-bold'>
              You can also ask your school, university, or employer to{' '}
              {/* <span className='underline'>
                support your learning on Recess.
              </span> */}
              <span
                className='underline'
                onClick={() =>
                  window.open('hub.recess.education/sponsors', '_blank')
                }
                style={{ cursor: 'pointer' }}
              >
                support your learning on Recess.
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
      {/* <Elements stripe={stripePromise}>
        <PaymentModal
          stripmodal={stripmodal}
          clientSecret={clientSecret}
          closestripModal={closestripModal}
          price={price}
          cuurency={cuurency}
        />
      </Elements> */}
    </div>
  )
}
export default Headings
